(function () {
	"use strict";

	if (!String.prototype.compare) {
		String.prototype.compare = function (b) {
			var a = this;
			if (a == b) {
				return 0;
			}
			if (a == null) {
				return -1;
			}
			if (b == null) {
				return 1;
			}
			return a < b ? -1 : 1;
		};
	}
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.compare.js